import Vue from 'vue'
import Vuex from 'vuex'
import parse from './store/modules/parse'
import date from './store/modules/date'
import error from './store/modules/error'
import snackBar from './store/modules/snackBar'
import app from './store/modules/app'
import country from './store/modules/country/index'
import event from './store/modules/event/index'
import eventClosed from './store/modules/eventClosed/index'
import eventQuizset from './store/modules/eventQuizset/index'
import eventQuizsetClosed from './store/modules/eventQuizsetClosed/index'
import eventExport from './store/modules/eventExport/index'
import entry from './store/modules/entry/index'
import entryClosed from './store/modules/entryClosed/index'
import user from './store/modules/user/index'
import info from './store/modules/info/index'
import bank from './store/modules/bank/index'
import message from './store/modules/message/index'
import quizset from './store/modules/quizset/index'
import quiz from './store/modules/quiz/index'
import tourism from './store/modules/tourism/index'
import option from './store/modules/option'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    parse,
    date,
    app,
    country,
    error,
    event,
    eventClosed,
    eventQuizset,
    eventQuizsetClosed,
    eventExport,
    entry,
    entryClosed,
    user,
    info,
    bank,
    message,
    quizset,
    quiz,
    tourism,
    snackBar,
    option,
  }
})
